import React from 'react';

export default function BandeauAdherent({ adherent, onDeconnecter }) {
  if (!adherent) return null;

  return (
    <div style={styles.wrap}>
      <div style={styles.info}>
        <span style={styles.avatar}>👤</span>
        <div>
          <div style={styles.nom}>{adherent.prenom} {adherent.nom}</div>
          <div style={styles.detail}>
            Bât. {adherent.batiment}
            {!adherent.cotisation_payee && <span style={styles.alerte}> · ⚠ Cotisation impayée</span>}
          </div>
        </div>
      </div>
      <button style={styles.btnDeco} onClick={onDeconnecter} title="Se déconnecter">
        🚪
      </button>
    </div>
  );
}

const styles = {
  wrap: {
    background: '#e8f0fe',
    borderBottom: '1px solid #c5d5f5',
    padding: '.45rem 1rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexShrink: 0,
  },
  info: { display: 'flex', alignItems: 'center', gap: '.55rem' },
  avatar: { fontSize: '1rem' },
  nom: { fontSize: '.8rem', fontWeight: 700, color: '#1a3a5c' },
  detail: { fontSize: '.68rem', color: '#666', marginTop: '.05rem' },
  alerte: { color: '#e65100', fontWeight: 600 },
  btnDeco: {
    background: 'none', border: 'none', cursor: 'pointer',
    fontSize: '.9rem', padding: '.2rem', color: '#888',
  },
};
